import clsx from 'clsx'
import { useIntl } from 'react-intl'
import { Medias } from '../../../enumns/medias'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { Header } from '../../landing/components/Header'

export const PrivacyPolicy = () => {
  const { formatMessage } = useIntl()
  const isTabletSize = useMediaQuery(`(min-width: ${Medias.LG}px)`)

  return (
    <>
    <Header />
    <div className="flex h-full bg-[#CEE2ED]">
      {isTabletSize && (
        <aside className="fixed overflow-y-scroll scrolltransparent top-[88px] left-0 flex flex-col pl-[87px] pr-[20px] pt-[60px] pb-24 h-screen max-w-[400px] w-full justify-start items-start bg-[#A3CBE1]">
        <h1 className="font-openSans mb-12 text-[32px] font-bold text-[#001D2F] mx-auto uppercase">
          {formatMessage({ id: 'INDEX' })}
        </h1>
        {Array.from({ length: 12 }, (_, index) => (
          <a
            key={index}
            className="font-montserrat mb-4 text-base font-semibold text-[#39393A] cursor-pointer"
            onClick={() => {
              const sectionId = [
                'important-definitions',
                'who-this-privacy-policy-applies-to',
                'website-collects-and-uses-the-following-personal-data',
                'purpose-of-processing-personal-data',
                'data-sharing-with-third-parties',
                'personal-data-retention-time',
                'rights-of-holders-of-personal-data',
                'cookie-policy',
                'security-of-personal-data',
                'legislation-and-jurisdiction',
                'modification-of-the-privacy-policy',
                'contact-information-for-questions'
              ][index]
              const sectionElement = document.getElementById(sectionId)
              if (sectionElement) {
                window.scrollTo({
                  top: sectionElement.offsetTop - 88,
                  behavior: 'smooth'
                })
              }
            }}
          >
            {index + 1}. {formatMessage({ id: `PRIVACY_POLICY_SUBTITLE_${index + 1}` })}
          </a>
        ))}
      </aside>
      )}
      <main className={clsx(
        'font-montserrat flex flex-col items-start justify-start w-full px-4 sm:px-16 mt-[88px]',
        isTabletSize ? 'ml-[400px]' : ''
      )}>
        <h1 className="font-openSans mb-16 text-[40px] font-bold text-[#001D2F] uppercase mt-[100px] mx-auto text-center">{formatMessage({ id: 'TRUST_INSIGHT_PRIVACY_POLICY' })}</h1>

        <div className="mb-[100px] whitespace-pre-line text-base font-medium text-[#39393A]">
          <span>{formatMessage({ id: 'PRIVACY_POLICY_SUMMARY' })}</span>

          <h2 id="important-definitions" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_1' })}</h2>
          <span dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'IMPORTANT_DEFINITIONS_TEXT' })
          }}></span>

          <h2 id="who-this-privacy-policy-applies-to" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_2' })}</h2>
          <span>{formatMessage({ id: 'WHO_THIS_PRIVACY_POLICY_APPLIES_TO_TEXT' })}</span>

          <h2 id="website-collects-and-uses-the-following-personal-data" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_3' })}</h2>
          <span>{formatMessage({ id: 'TRUST_INSIGHT_THROUGH_THE_WEBSITE_COLLECTS_AND_USES_THE_FOLLOWING_PERSONAL_DATA_TO_PROVIDE_ITS_SERVICES_TEXT' })}</span>

          <h2 id="purpose-of-processing-personal-data" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_4' })}</h2>
          <div className="grid grid-cols-2 sm:gap-x-[60px] gap-x-6 mb-6 items-center text-center font-bold whitespace-break-spaces">
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_LEFT_TITLE' })}</span>
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_RIGHT_TITLE' })}</span>
          </div>
          <div className="grid grid-cols-2 sm:gap-x-[60px] gap-x-6 mb-6 items-center whitespace-break-spaces">
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_LEFT_1' })}</span>
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_RIGHT_1' })}</span>
          </div>
          <div className="grid grid-cols-2 sm:gap-x-[60px] gap-x-6 mb-6 items-center whitespace-break-spaces">
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_LEFT_2' })}</span>
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_RIGHT_2' })}</span>
          </div>
          <div className="grid grid-cols-2 sm:gap-x-[60px] gap-x-6 mb-6 items-center whitespace-break-spaces">
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_LEFT_3' })}</span>
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_RIGHT_3' })}</span>
          </div>
          <div className="grid grid-cols-2 sm:gap-x-[60px] gap-x-6 mb-6 items-center whitespace-break-spaces">
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_LEFT_4' })}</span>
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_RIGHT_4' })}</span>
          </div>
          <div className="grid grid-cols-2 sm:gap-x-[60px] gap-x-6 mb-6 items-center whitespace-break-spaces">
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_LEFT_5' })}</span>
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_RIGHT_5' })}</span>
          </div>
          <div className="grid grid-cols-2 sm:gap-x-[60px] gap-x-6 mb-6 items-center whitespace-break-spaces">
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_LEFT_6' })}</span>
            <span>{formatMessage({ id: 'PURPOSE_OF_PROCESSING_PERSONAL_DATA_BY_TRUST_INSIGHT_TEXT_RIGHT_6' })}</span>
          </div>

          <h2 id="data-sharing-with-third-parties" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_5' })}</h2>
          <span>{formatMessage({ id: 'DATA_SHARING_WITH_THIRD_PARTIES_TEXT' })}</span>

          <h2 id="personal-data-retention-time" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_6' })}</h2>
          <span>{formatMessage({ id: 'PERSONAL_DATA_RETENTION_TIME_TEXT' })}</span>

          <h2 id="rights-of-holders-of-personal-data" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_7' })}</h2>
          <span className="break-all" dangerouslySetInnerHTML={{
            __html: formatMessage({ id: 'RIGHTS_OF_HOLDERS_OF_PERSONAL_DATA_TEXT' })
          }}></span>

          <h2 id="cookie-policy" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_8' })}</h2>
          <span>{formatMessage({ id: 'COOKIE_POLICY_TEXT' })}</span>
          <div className="grid grid-cols-3 md:gap-x-[60px] gap-x-2 mb-6 mt-8 items-center text-center break-all">
            <span className='font-bold'>{formatMessage({ id: 'COOKIE_POLICY_HEADER_LEFT' })}</span>
            <span className='font-bold'>{formatMessage({ id: 'COOKIE_POLICY_HEADER_CENTER' })}</span>
            <span className='font-bold'>{formatMessage({ id: 'COOKIE_POLICY_HEADER_RIGHT' })}</span>
          </div>
          <div className="grid grid-cols-3 md:gap-x-[60px] gap-x-2 mb-6 items-center text-justify break-all">
            <span className='text-center'>{formatMessage({ id: 'COOKIE_POLICY_TEXT_1_LEFT' })}</span>
            <span>{formatMessage({ id: 'COOKIE_POLICY_TEXT_1_CENTER' })}</span>
            <span>{formatMessage({ id: 'COOKIE_POLICY_TEXT_1_RIGHT' })}</span>
          </div>
          <div className="grid grid-cols-3 md:gap-x-[60px] gap-x-2 mb-8 items-center text-justify break-all">
            <span className='text-center'>{formatMessage({ id: 'COOKIE_POLICY_TEXT_2_LEFT' })}</span>
            <span>{formatMessage({ id: 'COOKIE_POLICY_TEXT_2_CENTER' })}</span>
            <span>{formatMessage({ id: 'COOKIE_POLICY_TEXT_2_RIGHT' })}</span>
          </div>
          <span>{formatMessage({ id: 'COOKIE_POLICY_TEXT2' })}</span>
          <ul className="list-disc list-inside mt-6 mb-6 break-all">
            <li>
              <span>{formatMessage({ id: 'COOKIE_POLICY_LINK_1_TITLE' })}</span>
            </li>
            <a href="https://www.google.com/intl/en/policies/technologies/cookies/" target="_blank" rel="noreferrer">{formatMessage({ id: 'COOKIE_POLICY_LINK_1' })}</a>
            <li className='mt-6'>
              <span>{formatMessage({ id: 'COOKIE_POLICY_LINK_2_TITLE' })}</span>
            </li>
            <a href="https://www.google.com/intl/en/policies/technologies/cookies/" target="_blank" rel="noreferrer">{formatMessage({ id: 'COOKIE_POLICY_LINK_2' })}</a>
            <li className='mt-6'>
              <span>{formatMessage({ id: 'COOKIE_POLICY_LINK_3_TITLE' })}</span>
            </li>
            <a href="https://www.google.com/intl/en/policies/technologies/cookies/" target="_blank" rel="noreferrer">{formatMessage({ id: 'COOKIE_POLICY_LINK_3' })}</a>
            <li className='mt-6'>
              <span>{formatMessage({ id: 'COOKIE_POLICY_LINK_4_TITLE' })}</span>
            </li>
            <a href="https://www.google.com/intl/en/policies/technologies/cookies/" target="_blank" rel="noreferrer">{formatMessage({ id: 'COOKIE_POLICY_LINK_4' })}</a>
          </ul>
          <span>{formatMessage({ id: 'COOKIE_POLICY_TEXT3' })}</span>

          <h2 id="security-of-personal-data" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_9' })}</h2>
          <span>{formatMessage({ id: 'SECURITY_OF_PERSONAL_DATA_TEXT' })}</span>

          <h2 id="legislation-and-jurisdiction" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_10' })}</h2>
          <span>{formatMessage({ id: 'LEGISLATION_AND_JURISDICTION_TEXT' })}</span>

          <h2 id="modification-of-the-privacy-policy" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_11' })}</h2>
          <span>{formatMessage({ id: 'MODIFICATION_OF_THE_PRIVACY_POLICY_TEXT_1' })}</span>

          <h2 id="contact-information-for-questions" className="font-openSans mt-12 mb-4 text-[32px] leading-[48px] font-semibold text-[#39393A]">{formatMessage({ id: 'PRIVACY_POLICY_SUBTITLE_12' })}</h2>
          <div className="flex flex-col gap-3 mb-10 flex-wrap">
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_1' })}</strong></span>
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_2' })}</strong> Trust Insight Ltda</span>
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_3' })}</strong> 37.671.002/0001-12</span>
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_4' })}</strong> Av. Brigadeiro Faria Lima, 2369 – conjunto 1102, Jardim Paulistano, São Paulo – SP</span>
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_5' })} agenda@trustinsight.com.br</strong></span>
          </div>
          <div className="flex flex-col gap-3 flex-wrap">
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_6' })}</strong></span>
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_7' })} Raul Fairbanks</strong></span>
            <span><strong>{formatMessage({ id: 'CONTACT_INFORMATION_FOR_QUESTIONS_8' })} raul@trustinsight.com.br</strong></span>
          </div>
        </div>
      </main>
    </div>
    </>
  )
}
